import { supabaseClient } from "@/lib/supabase";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@patient-watch/ui/sonner";
import { useToastCopy } from "@/features/i18n/toastCopy";

interface AddInvitedUserToOrgData {
    userId: string;
    organisationId: string;
    role: string;
}

const addInvitedUserToOrg = async (data: AddInvitedUserToOrgData) => {
    const { error } = await supabaseClient.from("users_organisations_roles").insert({
        user_id: data.userId,
        organisation_id: data.organisationId,
        role: data.role,
    });

    if (error) {
        throw new Error(error.message);
    }

    return data;
};

export const useAddInvitedUserToOrg = () => {
    const toastCopy = useToastCopy();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: addInvitedUserToOrg,
        onSuccess: () => {
            toast.success(toastCopy.organisationAdded);
            queryClient.invalidateQueries({ queryKey: ["team-members"] });
            queryClient.invalidateQueries({ queryKey: ["profiles"] });
        },
        onError: (error: Error) => {
            toast.error(toastCopy.errorAddingUserToOrganisation(error.message));
        },
    });
};
